import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usefile',
  templateUrl: './usefile.component.html',
  styleUrls: ['./usefile.component.css']
})
export class UsefileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
